import { render, staticRenderFns } from "./SowItem.vue?vue&type=template&id=507b1afd&scoped=true&"
import script from "./SowItem.vue?vue&type=script&lang=js&"
export * from "./SowItem.vue?vue&type=script&lang=js&"
import style0 from "./SowItem.vue?vue&type=style&index=0&id=507b1afd&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "507b1afd",
  null
  
)

export default component.exports